import { Star, Quote } from "lucide-react";
import { Reveal } from "./Reveal";
import { TESTIMONIALS } from "@/data/content";

export default function Testimonials({ limit }) {
  const items = limit ? TESTIMONIALS.slice(0, limit) : TESTIMONIALS;
  return (
    <section id="recenzii" className="py-20 lg:py-28 bg-[#FBF7EF]">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal className="max-w-2xl mx-auto text-center">
          <span className="text-xs font-semibold uppercase tracking-widest text-[#A6823B]">Recenzii pacienți</span>
          <h2 className="font-display text-3xl lg:text-4xl font-bold text-[#2A2521] mt-3">
            Peste 50.000 de pacienți ne acordă încrederea
          </h2>
          <div className="flex items-center justify-center gap-1.5 mt-4">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-[#A6823B] text-[#A6823B]" />)}
            <span className="ml-2 text-[#6B5C43] font-medium">4.9 / 5 din recenzii verificate</span>
          </div>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <Reveal key={t.name} delay={(i % 3) * 0.08}>
              <div data-testid="testimonial-card"
                className="h-full bg-white rounded-2xl border border-[#EADFC6] p-7 hover:shadow-xl hover:shadow-[#A6823B]/10 transition-shadow">
                <Quote className="w-8 h-8 text-[#A6823B]/30" />
                <div className="flex gap-1 mt-3">
                  {[...Array(t.rating)].map((_, s) => <Star key={s} className="w-4 h-4 fill-[#A6823B] text-[#A6823B]" />)}
                </div>
                <p className="text-[#4A3F2E] mt-3 leading-relaxed">"{t.text}"</p>
                <div className="mt-5 flex items-center gap-3">
                  <span className="w-10 h-10 rounded-full bg-[#EFE7D6] text-[#A6823B] flex items-center justify-center font-display font-bold">
                    {t.name.charAt(0)}
                  </span>
                  <div>
                    <div className="font-display font-bold text-[#2A2521] text-sm">{t.name}</div>
                    <div className="text-xs text-[#8A7A5E]">{t.city}</div>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
